import React, {forwardRef, useState} from 'react';
import BaseSimpleItemBrowser from "../BaseSimplePage/BaseSimpleItemBrowser";
import {getFullName} from "../../utils/PersonNameUtil";
import ArtistsItemBrowserHeader from "./ArtistsItemBrowserHeader";
import {allArtistRoles} from "../../data/Enums";

const ArtistsItemBrowser = forwardRef(({
                                             ...restProps
                                         }, ref) => {

    const [mainRoleId, setMainRoleId] = useState(0);
    const [tagId, setTagId] = useState(0);
    const [filterExtraParams, setFilterExtraParams] = useState({});

    function renderHeader(headerProps) {
        return <ArtistsItemBrowserHeader
            {...headerProps}
            mainRoleId={mainRoleId}
            setMainRoleId={handleMainRoleIdChange}
            tagId={tagId}
            setTagId={handleTagIdChange}
        />
    }

    function handleMainRoleIdChange(value) {
        const newFilterExtraParams = {...filterExtraParams};
        if (value === 0)
            delete newFilterExtraParams.main_role;
        else
            newFilterExtraParams.main_role = value;

        setMainRoleId(value);
        setFilterExtraParams(newFilterExtraParams);
        ref.current.onFilterEdit(true);
    }

    function handleTagIdChange(value) {
        const newFilterExtraParams = {...filterExtraParams};
        if (value === 0)
            delete newFilterExtraParams.tag_id;
        else
            newFilterExtraParams.tag_id = value;

        setTagId(value);
        setFilterExtraParams(newFilterExtraParams);
        ref.current.onFilterEdit(true);
    }

    return (
        <BaseSimpleItemBrowser
            {...restProps}
            ref={ref}
            getItemTitleFunc={getItemTitle}
            getItemSubtitleFunc={getItemSubTitle}
            renderHeaderFunc={renderHeader}
            filterExtraParams={filterExtraParams}
        />
    );
});

// TODO? share?
function getItemTitle(item) {
    return getFullName(item.first_name, item.last_name, item.middle_name);
}

function getItemSubTitle(item) {
    return allArtistRoles.find(x => x.id === item.main_role)?.name ?? "?";
}

export default ArtistsItemBrowser;